import React from "react";
import {FormattedMessage} from "react-intl";
import Dropzone from "react-dropzone";

// @mui/material components
import {CircularProgress} from "@mui/material";
import {makeStyles} from "@mui/styles";

// @mui/icons-material
import {CloudUpload, Delete} from "@mui/icons-material";

// core components
import Input from "components/input/input";

// styles
import {dangerColor, infoColor} from "../../../assets/jss/main";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {CKEditorConfig} from "../../../components/input/inputRenderer/wysiwygInputRenderer";

const useStyles = makeStyles(theme => ({
    formControl: {
        padding: "0px",
        width: "100%"
    },
    fieldContainer: {
        padding: "5px"
    },
    fieldLabel: {
        color: infoColor,
    },
    inputTextarea: {
        border: "2px solid #eee",
        borderRadius: "4px",
        width: "100%",
        padding: "8px 10px",
        boxShadow: "none",
        outline: "0",
        resize: "none",
        maxHeight: "200px",
        fontSize: "14px",
        "&::placeholder": {
            fontSize: "14px",
            color: "#acacac",
            fontWeight: "400",
            textAlign: "left",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
            opacity: "1",
            lineHeight: "1.42857",
        },
        "& img": {
            maxWidth: '100%',
        }
    },
    fieldUpload: {
        display: "flex",
        justifyContent: "space-between",
        flexFlow: 'column',
        position: 'relative',
        cursor: 'pointer',
        maxHeight: 'none',
    },
    fileUploadText: {
        color: "#acacac",
        paddingRight: '24px',
        wordBreak: 'break-all',
    },
    actions: {
        position: 'absolute',
        right: '10px',
        top: '8px',
        "&:last-chid":{
            border: "1px solid blue"
        }
    },
    upload: {
        "&:hover": {
            cursor: "pointer",
            color: infoColor
        },
    },
    delete: {
        marginRight: "5px",
        "&:hover": {
            cursor: "pointer",
            color: dangerColor
        }
    }
}));

export default function FormFields(props) {
    const { uploadLoading } = props;
    const classes = useStyles();

    function renderPictureName() {
        const contentUrl = props.picture && props.picture.contentUrl

        return (
            <>
                <div className={classes.fileUploadText}>
                    {contentUrl ? contentUrl.split('/').splice(-1) : <FormattedMessage id={"feed.form.file.upload"} />}
                </div>

                {contentUrl && <img src={contentUrl} alt={""} />}
            </>
        )
    }

    return (
        <div className={classes.fieldContainer}>
            <label htmlFor={`title_${props.name}`} className={classes.fieldLabel}>
                {props.label}
            </label>
            {props.type === "wysiwyg" && (
                <CKEditor
                    editor={ClassicEditor}
                    data={props.value}
                    config={CKEditorConfig}
                    onChange={( event, editor ) => {
                        props.onChange(editor.getData());
                    }}
                />
            )}
            {props.type === "text" && (
                <Input
                    type={props.type}
                    required={props.required}
                    disabled={props.disabled}
                    id={`title_${props.name}`}
                    inputProps={{
                        placeholder: props.placeholder,
                        type: props.type,
                        required: props.required,
                        disabled: props.disabled,
                        name: props.name,
                        value: props.value,
                        onChange: props.onChange,
                        autoComplete: props.autoComplete
                    }}
                    formControlProps={{
                        className: classes.formControl
                    }}
                />
            )}
            {props.type === "file" && (
                <Dropzone
                    name={props.name}
                    accept="image/*"
                    multiple={false}
                    onDrop={props.onDrop}
                >
                    {({getRootProps, getInputProps}) => {
                        return (
                            <div className={classes.fieldUpload + " " + classes.inputTextarea} {...getRootProps()}>
                                <input id={props.name} name={props.name} {...getInputProps()} />

                                <div className={classes.actions}>
                                    {uploadLoading ? (
                                        <CircularProgress size={24} />
                                    ) : (
                                            <>
                                                <CloudUpload className={classes.upload} />
                                                <Delete
                                                    className={classes.delete}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        props.onDeletePicture();
                                                    }}
                                                />
                                            </>
                                        )}
                                </div>

                                {renderPictureName()}
                            </div>
                        )
                    }}
                </Dropzone>
            )}
        </div>
    );
}
